import styled from 'styled-components';
import { Card } from 'fiducius-ui';

const ShadowAddCardNoBorder = styled(Card)`
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
`;

export default ShadowAddCardNoBorder;
